import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { TaskWorkflowByProfile } from '../model/task-workflow-by-profile';

@Injectable({
    providedIn: 'root'
  })
  export class TaskWorkflowByProfileService{
  

    constructor(private _restClientService : RestClientService) 
    {}
    
    getListTaskWorkflowByProfile() 
    {
      return this._restClientService.load<TaskWorkflowByProfile[]>('task-workflow-by-profile/task-workflow-by-profiles');
    }
      
    add(task) {
      return  this._restClientService.save<TaskWorkflowByProfile>('task-workflow-by-profile/add-task-workflow-by-profile', task);
    }
    
    update(task) {
      return  this._restClientService.put<TaskWorkflowByProfile>(`task-workflow-by-profile/update-task-workflow-by-profile`, task);
    }
  
    getTaskWorkflowByProfileById(taskId)
    {
      return this._restClientService.load<TaskWorkflowByProfile>('task-workflow-by-profile/task-workflow-by-profile-by-id/'+taskId);
    }
  
  
}      

    